import styled from 'styled-components';
import Title from 'components/Title';

export const Container = styled.ul`
  margin: 0;
  padding: 0;
  overflow-y: auto;
  height: 100%;
`;

export const StyledTitle = styled(Title)`
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.lightGrey};
  text-transform: none;
`;
